<template>
  <div>

    <div class="text-center">

      <v-img contain max-height="70px" :src="LogoSB" max-width="400" style=" margin: auto; " />

      <br>

    </div>

  </div>
</template>

<script>
import LogoSB from "@/assets/images/LogoFooter3.svg";
import LogoSB2 from "@/assets/images/LogoFooter33.svg";

export default {
  name: "Footer",
  mounted() {
  },
  data: () => ({
    LogoSB,
    LogoSB2,
    pathname: window.location.pathname,
    screen: window.screen.width,
  }),
  methods: {
    returnPage(index) {
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('benefData');
      sessionStorage.removeItem('servicesData');
      sessionStorage.removeItem('planData');
      if (index == 0) {
        window.location.href = 'https://southbridgeseguros.cl/';
      } else if (index == 1) {
        window.location.href = 'https://southbridgeseguros.cl/contacto';
      }
    }
  },

};
</script>

<style lang="scss" scoped>
@import url("../styles/main.scss");

.cobertura {
  font-family: Helvetica;
  font-style: normal;
  text-align: center;
  font-size: 15px;
  font-weight: 550;
  color: #232323;
  line-height: 16px;
  opacity: 0.75;
}

@media only screen and (max-width: 767px) {
  .cobertura {
    font-family: Helvetica;
    font-style: normal;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #232323;
    line-height: 13px;
    opacity: 0.75;
  }
}

.footer {
  height: 67px;
}

.footerFinish {
  // background-color: #2A3881;
}

.botonUse {
  display: flex;
  width: 241px;
  height: 52px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 40px;
  background: var(--Celeste-SB, #2A3881) !important;
  color: white !important;
  margin: auto;
}

.subLabelSub {
  color: var(--AD-Texto-1, #333);
  text-align: center;
  font-family: Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
}

</style>